export enum Permissions {
  All = 'all',
  AccessCommerce = 'access_commerce',
  AccessTasks = 'access_tasks',
  ActAsAdmin = 'act_as_admin',
  ActAsEditor = 'act_as_editor',
  AddComponent = 'add_component',
  AllowedLanguages = 'allowed_languages',
  ApplyToBlockSubfolders = 'apply_to_block_subfolders',
  AllowStorySlugChangeForDefaultLanguage = 'allow_story_slug_change_for_default_language',
  CanSubscribe = 'can_subscribe',
  ChangeAlternateGroup = 'change_alternate_group',
  CreateTasks = 'create_tasks',
  DeleteStories = 'delete_stories',
  DeleteTasks = 'delete_tasks',
  DenyComponentFieldsNameUpdate = 'deny_component_fields_name_update',
  DenyComponentTechnicalNameUpdate = 'deny_component_technical_name_update',
  DeployStories = 'deploy_stories',
  EditDataSources = 'edit_datasources',
  EditDataSourceKeys = 'edit_datasource_keys',
  EditField = 'edit_field',
  EditImage = 'edit_image',
  DenyUploadingAssets = 'deny_uploading_assets',
  DenyEditingAssets = 'deny_editing_assets',
  DenyDeletingAssets = 'deny_deleting_assets',
  DenyMovingAssets = 'deny_moving_assets',
  DenyCreatingAssetFolders = 'deny_creating_asset_folders',
  DenyUpdatingAssetFolders = 'deny_updating_asset_folders',
  DenyMovingAssetFolders = 'deny_moving_asset_folders',
  DenyDeletingAssetFolders = 'deny_deleting_asset_folders',
  EditLanguages = 'edit_languages',
  EditStorySlug = 'edit_story_slug',
  EditStorySlugOnlyForAllowedLanguages = 'edit_story_slug_only_for_allowed_languages',
  EditTasks = 'edit_tasks',
  ExecuteTasks = 'execute_tasks',
  ForceRelease = 'force_release',
  PrivateReleasesFullAccess = 'private_releases_full_access',
  HideAssetFolders = 'hide_asset_folders',
  ManageAssetFolders = 'manage_asset_folders',
  ManageConcepts = 'manage_concepts',
  ManageBlockLibrary = 'manage_block_library',
  ManageNonTranslatableFields = 'manage-non-translatable-fields',
  ManageTags = 'manage_tags',
  MoveStory = 'move_story',
  PublishFolders = 'publish_folders',
  PublishStories = 'publish_stories',
  ReadStories = 'read_stories',
  RestrictDimensionsApp = 'restrict_dimensionsapp',
  RestrictDimensionsAppClone = 'restrict_dimensionsapp_clone',
  RestrictDimensionsAppMerge = 'restrict_dimensionsapp_merge',
  RestrictDimensionsAppOverwrite = 'restrict_dimensionsapp_overwrite',
  SaveStories = 'save_stories',
  UnPublishFolders = 'unpublish_folders',
  UnPublishStories = 'unpublish_stories',
  ViewComposer = 'view_composer',
  ViewContent = 'view_content',
  ViewDraftJSON = 'view_draft_json',
  ViewField = 'view_field',
  ViewFolders = 'view_folders',
  ViewPublishedJSON = 'view_published_json',
  PrioritizeContentAccessRestriction = 'prioritize_content_access_restriction',
  AllowSpaceDuplication = 'allow_space_duplication',
}
